/**
 * Spend-threshold complimentary voucher
 * Adds a voucher product when qualifying cart spend hits the configured threshold.
 * Qualifying spend is the total of cart lines in the collection from
 * Theme settings → Cart → Spend voucher collection handle.
 * Calculated in templates/cart.ajax.liquid (cart.js does not include collections).
 * Storefront adds of this variant are blocked unless this script adds them.
 * Use products/warehouse-test-test-product-testing-only (ID: 7218909544501) to test the flow.
 */
(function () {
  var cfg = (window.theme && theme.spendVoucher) || {};
  if (cfg.enabled === false) return;

  var PRODUCT_ID = String(cfg.productId || "15880180302207");
  var VARIANT_ID = parseInt(cfg.variantId, 10) || 58381428621695;
  var HANDLE = cfg.handle || "";
  var THRESHOLD = parseInt(cfg.threshold, 10) || 100000;

  var state = {
    isUpdating: false,
    debounceTimer: null,
    refreshTimer: null,
    suppressUntil: 0,
    allowInternalAdd: false,
    allowCheckout: false,
    checkoutHold: false,
  };

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    var pageUrl = (window.theme && theme.routes && theme.routes.cartPage) || "/cart";
    var join = pageUrl.indexOf("?") === -1 ? "?" : "&";
    var ajaxUrl = pageUrl + join + "view=ajax&t=" + Date.now();

    return Promise.all([
      fetchJSON("/cart.js"),
      fetch(ajaxUrl, { credentials: "same-origin" }).then(function (r) {
        if (!r.ok) throw new Error("ajax cart " + r.status);
        return r.text();
      }),
    ]).then(function (results) {
      var cart = results[0];
      var match = String(results[1] || "").match(/data-qualifying-spend="(\d+)"/);
      if (!match) throw new Error("missing qualifying spend");
      cart.qualifyingSpend = parseInt(match[1], 10) || 0;
      cart.hasTestProduct = /data-test-product="true"/.test(results[1]);
      return cart;
    });
  }

  function isVoucher(item) {
    if (!item) return false;
    if (String(item.product_id) === PRODUCT_ID) return true;
    if (HANDLE && item.handle === HANDLE) return true;
    var props = item.properties || {};
    return props._promo === "spend-voucher";
  }

  function qualifyingSpend(cart) {
    if (!cart || typeof cart.qualifyingSpend !== "number") return 0;
    // TESTING only: zero-value test product (ID 7218909544501) forces eligibility.
    if (cart.hasTestProduct) return Math.max(cart.qualifyingSpend, THRESHOLD);
    return cart.qualifyingSpend;
  }

  function findVoucherLine(cart) {
    var found = null;
    (cart.items || []).forEach(function (item) {
      if (isVoucher(item)) found = item;
    });
    return found;
  }

  function updateNotice(cart) {
    var notice = document.getElementById("spend-voucher-notice");
    if (!notice) return;
    var visible = !!findVoucherLine(cart);
    notice.hidden = !visible;
    notice.classList.toggle("is-visible", visible);
  }

  function collectIds(value, ids) {
    if (value == null) return;
    if (typeof value === "number") {
      ids.push(value);
      return;
    }
    if (typeof value === "string") {
      var trimmed = value.replace(/^\s+|\s+$/g, "");
      if (!trimmed) return;
      if (trimmed.charAt(0) === "{" || trimmed.charAt(0) === "[") {
        try {
          collectIds(JSON.parse(trimmed), ids);
        } catch (e) {
          collectIdsFromQuery(trimmed, ids);
        }
        return;
      }
      collectIdsFromQuery(trimmed, ids);
      return;
    }
    if (typeof FormData !== "undefined" && value instanceof FormData) {
      value.forEach(function (v, k) {
        if (k === "id" || k.indexOf("[id]") !== -1) ids.push(parseInt(v, 10));
      });
      return;
    }
    if (typeof URLSearchParams !== "undefined" && value instanceof URLSearchParams) {
      value.forEach(function (v, k) {
        if (k === "id" || k.indexOf("[id]") !== -1) ids.push(parseInt(v, 10));
      });
      return;
    }
    if (typeof value === "object") {
      if (value.id != null) ids.push(parseInt(value.id, 10));
      if (value.items && value.items.length) {
        value.items.forEach(function (item) {
          if (item && item.id != null) ids.push(parseInt(item.id, 10));
        });
      }
    }
  }

  function collectIdsFromQuery(str, ids) {
    var parts = String(str).split("&");
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split("=");
      var k = decodeURIComponent((kv[0] || "").replace(/\+/g, " "));
      var v = decodeURIComponent((kv.slice(1).join("=") || "").replace(/\+/g, " "));
      if (k === "id" || k.indexOf("[id]") !== -1) ids.push(parseInt(v, 10));
    }
  }

  function isCartAddUrl(url) {
    return String(url).indexOf("/cart/add") !== -1;
  }

  function isVoucherPermalink(url) {
    if (!VARIANT_ID) return false;
    return String(url).indexOf("/cart/" + VARIANT_ID) !== -1;
  }

  function requestAddsVoucher(url, body) {
    if (!VARIANT_ID) return false;
    if (isVoucherPermalink(url)) return true;
    if (!isCartAddUrl(url)) return false;
    if (String(url).indexOf(String(VARIANT_ID)) !== -1) return true;
    var ids = [];
    collectIds(body, ids);
    for (var i = 0; i < ids.length; i++) {
      if (ids[i] === VARIANT_ID) return true;
    }
    return false;
  }

  function blockedAddResponse() {
    return Promise.resolve(
      new Response(
        JSON.stringify({
          status: 422,
          message: "Cart Error",
          description: "This item cannot be added to the cart",
        }),
        {
          status: 422,
          headers: { "Content-Type": "application/json" },
        }
      )
    );
  }

  function installFetchGuard() {
    if (!window.fetch || window.fetch.__svGuard) return;
    var orig = window.fetch;
    function wrapped(input, init) {
      var url = "";
      var body = init && init.body;
      if (typeof input === "string") url = input;
      else if (input && input.url) url = input.url;
      if (!state.allowInternalAdd && requestAddsVoucher(url, body)) {
        return blockedAddResponse();
      }
      return orig.apply(this, arguments);
    }
    wrapped.__svGuard = true;
    window.fetch = wrapped;
  }

  function installXhrGuard() {
    if (XMLHttpRequest.prototype.open.__svGuard) return;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__svUrl = url == null ? "" : String(url);
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.open.__svGuard = true;
    XMLHttpRequest.prototype.send = function (body) {
      if (!state.allowInternalAdd && requestAddsVoucher(this.__svUrl, body)) {
        return origSend.call(this, JSON.stringify({ id: 0, quantity: 0 }));
      }
      return origSend.apply(this, arguments);
    };
  }

  function installJqueryGuard() {
    if (!window.jQuery || !jQuery.ajaxPrefilter) return;
    if (jQuery.ajaxPrefilter.__svGuard) return;
    jQuery.ajaxPrefilter(function (options) {
      if (state.allowInternalAdd) return;
      if (requestAddsVoucher(options.url, options.data)) {
        options.data = { id: 0, quantity: 0 };
      }
    });
    jQuery.ajaxPrefilter.__svGuard = true;
  }

  function addVoucher() {
    if (!VARIANT_ID) {
      console.warn(
        "[SpendVoucher] Missing variant ID. Set Theme settings → Cart → Spend voucher variant ID.",
      );
      return Promise.resolve(false);
    }
    state.allowInternalAdd = true;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: VARIANT_ID,
        quantity: 1,
        properties: { _promo: "spend-voucher" },
      }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            console.warn("[SpendVoucher] add failed", r.status, data);
            return false;
          }
          return true;
        });
      })
      .finally(function () {
        state.allowInternalAdd = false;
      });
  }

  function changeLine(key, quantity) {
    return fetchJSON("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  function scheduleRefresh() {
    if (state.refreshTimer) return;
    state.suppressUntil = Date.now() + 1500;
    state.refreshTimer = setTimeout(function () {
      state.refreshTimer = null;
      try {
        // Theme CartForm listens for cart:build and replaces [data-products].
        // Do not call refreshCartDrawer — it targets .cart-drawer__body, which
        // this theme does not render, so the drawer never updates.
        document.dispatchEvent(new CustomEvent("cart:build"));
      } catch (e) {}
      getCart()
        .then(function (cart) {
          updateNotice(cart);
        })
        .catch(function () {});
    }, 250);
  }

  function ensure(cart) {
    if (!cart || state.isUpdating) return Promise.resolve(false);
    var eligible = qualifyingSpend(cart) >= THRESHOLD;
    var existing = findVoucherLine(cart);

    if (eligible && existing && existing.quantity > 1) {
      state.isUpdating = true;
      state.suppressUntil = Date.now() + 1200;
      return changeLine(existing.key, 1)
        .then(function () {
          return true;
        })
        .finally(function () {
          state.isUpdating = false;
        });
    }

    if (eligible && !existing) {
      state.isUpdating = true;
      state.suppressUntil = Date.now() + 1200;
      return addVoucher()
        .catch(function (err) {
          console.warn("[SpendVoucher] add failed", err);
          return false;
        })
        .finally(function () {
          state.isUpdating = false;
        });
    }

    if (!eligible && existing) {
      state.isUpdating = true;
      state.suppressUntil = Date.now() + 1200;
      return changeLine(existing.key, 0)
        .then(function () {
          return true;
        })
        .finally(function () {
          state.isUpdating = false;
        });
    }

    return Promise.resolve(false);
  }

  function run() {
    getCart()
      .then(function (data) {
        updateNotice(data);
        var existing = findVoucherLine(data);
        var eligible = qualifyingSpend(data) >= THRESHOLD;
        if (existing && !eligible) {
          return ensure(data).then(function (changed) {
            if (changed) scheduleRefresh();
          });
        }
        if (Date.now() < state.suppressUntil) return;
        return ensure(data).then(function (changed) {
          if (changed) scheduleRefresh();
          else updateNotice(data);
        });
      })
      .catch(function () {});
  }

  function onCartEvent() {
    if (state.debounceTimer) clearTimeout(state.debounceTimer);
    state.debounceTimer = setTimeout(function () {
      state.debounceTimer = null;
      run();
    }, 400);
  }

  function isCheckoutControl(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest('button[name="checkout"], input[name="checkout"], .cart__checkout');
    if (btn) return btn;
    var a = el.closest("a");
    if (a && a.href && String(a.href).indexOf("/checkout") !== -1) return a;
    return null;
  }

  function guardCheckout(trigger) {
    if (state.allowCheckout) return false;
    if (state.checkoutHold) return true;
    state.checkoutHold = true;
    getCart()
      .then(function (cart) {
        return ensure(cart).then(function (changed) {
          if (changed) scheduleRefresh();
          return getCart();
        });
      })
      .then(function (cart) {
        state.checkoutHold = false;
        var existing = findVoucherLine(cart);
        var eligible = qualifyingSpend(cart) >= THRESHOLD;
        if (existing && !eligible) return;
        if (!(cart.items || []).length) return;
        state.allowCheckout = true;
        if (trigger && trigger.click) trigger.click();
        else window.location.href = "/checkout";
        setTimeout(function () {
          state.allowCheckout = false;
        }, 1500);
      })
      .catch(function () {
        state.checkoutHold = false;
      });
    return true;
  }

  installFetchGuard();
  installXhrGuard();
  installJqueryGuard();
  setTimeout(installJqueryGuard, 0);
  setTimeout(installJqueryGuard, 500);

  document.addEventListener("ajaxProduct:added", onCartEvent);
  document.addEventListener("cart:updated", onCartEvent);
  document.addEventListener("cart:open", onCartEvent);
  window.addEventListener("pageshow", function () {
    installJqueryGuard();
    run();
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      installJqueryGuard();
      run();
    });
  } else {
    installJqueryGuard();
    run();
  }

  document.addEventListener(
    "click",
    function (e) {
      var a = e.target.closest && e.target.closest("a");
      if (a && isVoucherPermalink(a.href)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var checkout = isCheckoutControl(e.target);
      if (checkout && guardCheckout(checkout)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form) return;
      var action = form.getAttribute("action") || form.action || "";
      if (!state.allowInternalAdd && requestAddsVoucher(action, new FormData(form))) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var submitter = e.submitter;
      if (submitter && submitter.name === "checkout" && guardCheckout(submitter)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
})();
